var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recipient-container py-2" },
    [
      _c(
        "b-row",
        { staticClass: "align-items-center mb-2" },
        [
          _c("b-col", { staticClass: "sticky-top", attrs: { cols: "6" } }, [
            _c("div", { staticClass: "right-inner-addon" }, [
              _c("i", {
                staticClass: "fa fa-search",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.searchString,
                    expression: "searchString",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  id: "drip-campaign-search-modal-id",
                  type: "search",
                  placeholder: _vm.$t("drip-campaigns.actions.searchFor"),
                  autocomplete: "off",
                },
                domProps: { value: _vm.searchString },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchString = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  attrs: {
                    for: "drip-campaign-search-modal-id",
                    hidden: "true",
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("drip-campaigns.actions.searchFor")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "vertical-center justify-content-end",
              attrs: { cols: "6" },
            },
            [
              _c(
                "inline-prompt",
                {
                  staticClass: "clickable d-flex flex-row justify-content-end",
                  staticStyle: { "font-size": "0.8rem" },
                  attrs: {
                    disabled:
                      _vm.bulkDeleteLoading.loading || !_vm.anyClientSelected,
                    "action-type": "delete",
                    placement: "left",
                    "confirmation-text": _vm.$t("global.actions.confirmDelete"),
                  },
                  on: { accept: _vm.handleBulkDelete },
                },
                [
                  _c("simple-button", {
                    attrs: {
                      text: _vm.$t("global.actions.deleteSelected"),
                      type: "danger",
                      "class-name": "btn-sm",
                      disabled:
                        _vm.bulkDeleteLoading.loading || !_vm.anyClientSelected,
                      loading: _vm.bulkDeleteLoading.loading,
                      "loading-succeeded":
                        _vm.bulkDeleteLoading.loadingSucceeded,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("v-server-table", {
                ref: "table",
                staticClass:
                  "vue-custom-table no-pagination vue-custom-table-infinite drip-campaign-modal-table",
                attrs: {
                  columns: _vm.tableOptions.columns,
                  options: _vm.tableOptions.options,
                },
                on: {
                  loading: _vm.handleTableLoading,
                  loaded: _vm.handleTableLoaded,
                },
                scopedSlots: _vm._u([
                  {
                    key: "selected",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        !row.deleted
                          ? _c("div", { staticClass: "form-group-checkbox" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-jelly p-smooth p-curve mr-0",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.clientsMarkedForDeletion[
                                            row.clientProfileId
                                          ],
                                        expression:
                                          "clientsMarkedForDeletion[row.clientProfileId]",
                                      },
                                    ],
                                    staticClass: "checkbox",
                                    attrs: {
                                      id: "selected-" + row.clientProfileId,
                                      type: "checkbox",
                                      disabled: _vm.loading,
                                      name: "selected-" + row.clientProfileId,
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.clientsMarkedForDeletion[
                                          row.clientProfileId
                                        ]
                                      )
                                        ? _vm._i(
                                            _vm.clientsMarkedForDeletion[
                                              row.clientProfileId
                                            ],
                                            null
                                          ) > -1
                                        : _vm.clientsMarkedForDeletion[
                                            row.clientProfileId
                                          ],
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.clientsMarkedForDeletion[
                                              row.clientProfileId
                                            ],
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.clientsMarkedForDeletion,
                                                row.clientProfileId,
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.clientsMarkedForDeletion,
                                                row.clientProfileId,
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.clientsMarkedForDeletion,
                                            row.clientProfileId,
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "state p-success" },
                                    [
                                      _c("i", {
                                        staticClass: "icon fa fa-check",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for:
                                              "selected-" + row.clientProfileId,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { display: "none" },
                                            },
                                            [_vm._v("nodisplay")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "name",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.givenName) +
                            " " +
                            _vm._s(row.familyName) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                  {
                    key: "email",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " + _vm._s(row.email) + "\n        "
                        ),
                      ]
                    },
                  },
                  {
                    key: "stage",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " + _vm._s(row.state) + "\n        "
                        ),
                      ]
                    },
                  },
                  {
                    key: "active",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.active
                          ? _c("em", {
                              staticClass: "text-success fa fa-check",
                            })
                          : _c("em", {
                              staticClass: "text-danger fa fa-times",
                            }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }